import { getQueryStringFromOptions, getResponse } from '@satellite/services/serviceUtilities';
import { cachedInflightRequest } from '@nova/core';

export default {
  async getOneById(spotAreaId, params, options = {}) {
    const queryString = getQueryStringFromOptions(options);

    // Generate a unique cache key
    const cacheKey = `yard/spot-area/getOneById:${spotAreaId}:${JSON.stringify(
      params
    )}:${queryString}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get(`yard/spot-area/${spotAreaId}?${queryString}`, {
        params
      });
      return getResponse(response, options);
    });
  },
  async getManyByWarehouseId(warehouseId, params = {}, options = {}) {
    const queryString = getQueryStringFromOptions(options);

    // Generate a unique cache key
    const cacheKey = `yard/spot-area/getManyByWarehouseId:${warehouseId}:${JSON.stringify(
      params
    )}:${queryString}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get(`yard/spot-area?${queryString}`, {
        params: { ...params, s: { warehouseId } }
      });

      return getResponse(response, options);
    });
  },
  async create(data, options = {}) {
    const response = await axios.post('yard/spot-area', data);
    return getResponse(response, options);
  },
  async update(id, data, options = {}) {
    const response = await axios.patch(`yard/spot-area/${id}`, data);
    return getResponse(response, options);
  },
  async delete(id, options = {}) {
    const response = await axios.delete(`yard/spot-area/${id}`);
    return getResponse(response, options);
  }
};
